// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

// slick
import $ from 'jquery';
import 'third/jquery.slick';

export default class ColorDescriptionSlider extends WebComponent {
  didMount() {
    const slider = $('.color-description-slider');
    setTimeout(() => {
      $(this.element).slick({
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          prevArrow: '<span class="color-description-slider__arrow color-description-slider__arrow--prev"><svg class="svg-icon"><use xlink:href="#arrow-left"></use></svg></span>',
          nextArrow: '<span class="color-description-slider__arrow color-description-slider__arrow--next"><svg class="svg-icon"><use xlink:href="#arrow-right"></use></svg></span>',
          infinite: true,
          speed: 800,
          cssEase: 'ease-in-out',
          draggable: true,
          fade: true,
          //adaptiveHeight: true,
        });
    }, 100);

    $(window).resize(() => {
      $(slider)[0].slick.refresh();
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ColorDescriptionSlider.js